import { GameDrawerBase } from './gameDrawer.base';
import { backgroundDrawer } from '../background';
import { webConfig } from '../../../core/pixi/config';
import { gameResources } from '../../../core/pixi/resources/resources.shared';

export class GameDrawerWeb extends GameDrawerBase {
  draw() {
    backgroundDrawer.execute(this.layers, webConfig);
  }

  loadResource() {
    return super.loadResource(gameResources, this.createLoader());
  }
}
